import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {useEffect, useState} from 'react';
import {useApi} from "../provider/ApiProvider";
import {useHistory} from "react-router-dom";
import moment from 'moment';
import {Button, Popconfirm} from "antd";
import {DeleteOutlined, EditFilled, NotificationOutlined, PlusOutlined} from "@ant-design/icons";

export default function NewsPage(){
    const {api} = useApi();
    let history = useHistory();

    const [loading, setLoading] = useState(false);
    const [news, setNews] = useState({totalCount: 0, data: []})

    useEffect(() => {
        load();
    },[])

    async function load(){
        api.get('/newsRouter/news/all').then(resp => {
            console.log(resp.data, 'resp');
            setNews({totalCount: resp.totalCount, items: resp.data})
        })
    }

    function clickRow(item){
        history.push("/news/add/" + item.id);
    }


    async function deleteRow(id){
        await api.delete('/newsRouter/news/delete?id=' + id).then(resp => {
            load();
        })
    }

    async function SendRow(values){
        setLoading(true);

        await api.post('/notificationRouter/send',{
            customerId: values.CustomerId,
            title: values.title,
            message: values.content,
            dataid: values.id,
        }).then(resp => {
            setLoading(false);
        }).finally(() => {
            setLoading(false);
        })
    }

    const columns = [

        {
            title: 'Başlık',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Oluşturulma Tarihi',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: record => moment(record.createdAt).format('DD.MM.YY')
        },
        {
            title: 'İşlemler',
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button danger><DeleteOutlined/></Button>
                    </Popconfirm>

                    <Button style={{marginLeft: '4%'}} onClick={() => clickRow(record)}>
                        <EditFilled />
                    </Button>

                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {SendRow(record)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button style={{marginLeft: '4%'}} succes><NotificationOutlined /></Button>
                    </Popconfirm>

                </div>
            )
        }
    ]

    return (
        <LayoutComponent
            title={"Bildirimler"}
            links={
                [
                    {
                        title: 'Bildrimler',
                        url: '/news'
                    },
                ]}
            newButton={<>
                <Button icon={<PlusOutlined />} onClick={() => history.push('/news/add')} type="primary">Ekle</Button>
            </>}
        >
            <TableComponent
                loading={loading}
                columns={columns}
                data={news}
                clickAddButton={() => {history.push('/news/add')}}
            />
        </LayoutComponent>
    )
}
